import { appSchema } from '@nozbe/watermelondb'

import base_schema from '../migrations/base_schema'

export default appSchema(base_schema)
